export const GrainOverlay = () => (
  <>
    <svg className="grain-overlay" aria-hidden="true">
      <filter id="grain-filter">
        <feTurbulence type="fractalNoise" baseFrequency="0.8" numOctaves="3" stitchTiles="stitch" />
      </filter>
      <rect width="100%" height="100%" filter="url(#grain-filter)" />
    </svg>
    <div className="grid-lines" aria-hidden="true" />
  </>
);
